/* eslint-disable no-unused-vars */

if ($('.js-facet-selector-back').length > 0) {
  $('body').on('click', '.js-facet-selector-back', function (e) {
    e.preventDefault();
    window.history.back();
  });
}

if ($('#product-list-container').length > 0) {
  $(window).on('popstate', function (e) {
    console.log('event', e);
    if (e.originalEvent.state && e.originalEvent.state.pushCheck) {
      var returnLocation = history.location || document.location;
      window.location.href = returnLocation;
    } else {
      location.reload();
    }
  });
}

// Product Facets
$('#product-filters').on('click', 'a.filter-variant', function (event) {
  event.preventDefault();
  event.stopPropagation();
  $(this).toggleClass('filter-variant--selected');
  var input = $(this).find('input.filter-variant__input');
  if ($(this).hasClass('filter-variant--selected')) {
    input.val('1');
  } else {
    input.val('0');
  }
  UpdateFacets($(this).attr('href'));
});

$('#product-filters').on('click', '#clear-filters', function (event) {
  event.preventDefault();
  event.stopPropagation();
  $('input.filter-variant__input').val('0');
  $('.filter-variant.filter-variant--selected').removeClass(
    'filter-variant--selected'
  );
  UpdateFacets($(this).attr('href'));
});

// Product Pager Links
$('#product-list-container').on('click', 'a.page-link', function (event) {
  event.preventDefault();
  event.stopPropagation();
  $('#update-product-list-page').val($(this).data('page'));
  UpdatePageListProducts($(this).attr('href'), false);
});

// Product Show Switch
$('#product-list-container').on(
  'change',
  '.js-product-show-select',
  function (event) {
    var optionSelected = $('option:selected', this);
    $('#update-product-list-show').val(this.value);
    $('#update-product-list-page').val(1);
    $('#facets-facet-show').val(this.value);

    UpdatePageListProducts(optionSelected.data('url'), true);
  }
);

// Product Sort Switch
$('#product-list-container').on(
  'change',
  '.js-product-sort-select',
  function (event) {
    var optionSelected = $('option:selected', this);
    $('#update-product-list-sort').val(this.value);
    $('#update-product-list-page').val(1);
    $('#facets-facet-sort').val(this.value);

    UpdatePageListProducts(optionSelected.data('url'), true);
  }
);

function UpdateFacets(newUrl) {
  var selectedFacets = GetSelectedFacetIds();
  var selectedFacetValues = GetSelectedFacetValues();

  $('#update-product-list-page').val(1);
  $('#facets-facet-ids').val(selectedFacets);
  $('#update-product-list-facet-ids').val(selectedFacets);
  $('#facets-facet-filters').val(selectedFacetValues);
  $('#update-product-list-filters').val(selectedFacetValues);

  UpdatePageListProducts(newUrl, true);
}

function GetSelectedFacetIds() {
  var selected = [];

  $('#product-filters a.filter-variant').each(function (i, ftype) {
    $(ftype)
      .find('input.filter-variant__input[value="1"]')
      .each(function (j, fvalue) {
        selected.push($(fvalue).data('facet-value-id'));
      });
  });
  return selected.join('-');
}

function GetSelectedFacetValues() {
  var selected = [];

  $('#product-filters a.filter-variant').each(function (i, ftype) {
    $(ftype)
      .find('input.filter-variant__input[value="1"]')
      .each(function (j, fvalue) {
        // get data via attr or strs that look like ints will error
        selected.push(
          $(fvalue)
            .attr('data-facet-value')
            .replace(/[_<> /%"]/g, '-')
            .replace('&', 'and')
            .replace('+', 'plus')
        );
      });
  });
  return selected.join('_');
}

function UpdateUrl(newUrl) {
  // window.location.href = newUrl;
  history.pushState(
    {
      pushCheck: true
    },
    'Products',
    newUrl
  );
}

function UpdatePageListProducts(newUrl, updateFacets) {
  UpdateUrl(newUrl);

  if (updateFacets) $('form#update-category-facets').trigger('submit');

  $('#product-list-loader').addClass('product-list-loader--visible');

  $('form#update-product-list').trigger('submit');
  $('html, body').animate(
    {
      scrollTop: $('div.main-content').offset().top
    },
    500
  );
}
